import topbar from "topbar"

import { getCssCustomProperties } from "../utils/custom-properties"

export default function initLoadingBar() {
  let timeout = null
  let headerObserver = null

  const cssCustomProps = getCssCustomProperties([
    `--color-alice-blue`,
    `--color-sea-green`,
    `--color-black-faded`,
  ])

  topbar.config({
    barThickness: 4,
    barColors: { 0: cssCustomProps[`--color-alice-blue`] },
    shadowColor: cssCustomProps[`--color-black-faded`],
    shadowBlur: 5,
  })

  const setBarColor = (headerVisible) => {
    topbar.config({
      barColors: {
        0: cssCustomProps[
          headerVisible ? `--color-alice-blue` : `--color-sea-green`
        ],
      },
    })
  }

  // the bar takes the header's color while the header is in view; observed
  // only while loading, and looked up anew each time as live navigation
  // replaces the header. The first callback reports the current state right
  // away, before the bar shows
  const observeHeader = () => {
    const header = document.querySelector(`.header`)
    if (!header) {
      setBarColor(false)
      return
    }

    headerObserver = new IntersectionObserver(([entry]) =>
      setBarColor(entry.isIntersecting)
    )
    headerObserver.observe(header)
  }

  window.addEventListener(`phx:page-loading-start`, () => {
    if (timeout) return

    observeHeader()
    timeout = window.setTimeout(() => topbar.show(), 120)
  })

  window.addEventListener(`phx:page-loading-stop`, () => {
    topbar.hide()
    clearTimeout(timeout)
    timeout = null
    headerObserver?.disconnect()
    headerObserver = null
  })
}
